"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputChecks = void 0;
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const modeNode = FSIServerClientUtils_1.FSIServerClientUtils.GET_MODE_NODE();
class InputChecks {
    static CHECK_ARGUMENT_TYPE(val, argName, expectedType) {
        const isType = typeof (val);
        if (isType !== expectedType) {
            InputChecks.THROW_ERROR("Expected argument '" + argName + "' to be of type '" + expectedType
                + "', but received type '" + isType + "'");
        }
    }
    static IS_ARRAY(val, argName) {
        if (modeNode)
            return;
        if (typeof (val) !== "object" || typeof (val.concat) !== "function") {
            InputChecks.THROW_ERROR("Expected argument '" + argName + "' to be an array, but received type '" + typeof (val) + "'.");
        }
    }
    static IS_ARRAY_NOT_EMPTY(val, argName) {
        InputChecks.IS_ARRAY(val, argName);
        if (val.length < 1) {
            InputChecks.THROW_ERROR("Expected '" + argName + "' to be a non empty array.");
        }
    }
    static ARRAY_CONTAINS(val, argName, type) {
        if (modeNode)
            return;
        for (const item of val) {
            if (typeof (item) !== type) {
                InputChecks.THROW_ERROR("Argument '" + argName + "' may only contain elements of type '" + type + "'.");
            }
        }
    }
    static IS_STRING(val, argName) {
        if (modeNode)
            return;
        InputChecks.CHECK_ARGUMENT_TYPE(val, argName, "string");
    }
    static IS_STRING_NOT_EMPTY(val, argName) {
        InputChecks.IS_STRING(val, argName);
        if (val.length < 1) {
            InputChecks.THROW_ERROR("Argument '" + argName + "' may not be an empty string.");
        }
    }
    static PATH(path, argName = "path") {
        InputChecks.IS_STRING_NOT_EMPTY(path, argName);
    }
    static LOGIN(username, password) {
        InputChecks.IS_STRING_NOT_EMPTY(username, "username");
        InputChecks.IS_STRING_NOT_EMPTY(password, "password");
    }
    static LIST_SERVER(path, options = {}) {
        InputChecks.PATH(path);
        InputChecks.IS_OBJECT(options, "options");
    }
    static STRING(str, argName = "path") {
        if (modeNode)
            return;
        InputChecks.IS_STRING(str, argName);
    }
    static IS_BOOL(bool, argName) {
        if (modeNode)
            return;
        InputChecks.CHECK_ARGUMENT_TYPE(bool, argName, "boolean");
    }
    static IS_OBJECT(obj, argName) {
        InputChecks.CHECK_ARGUMENT_TYPE(obj, argName, "object");
        if (obj === null)
            InputChecks.THROW_ERROR("Expected argument '" + argName + "' to be an object, but received 'null'");
    }
    static IS_FN(fn, argName) {
        InputChecks.CHECK_ARGUMENT_TYPE(fn, argName, "function");
    }
    static FN_CTX_OR_UNDEFINED(some, argName) {
        if (some !== undefined) {
            InputChecks.IS_OBJECT(some, argName);
            InputChecks.IS_OBJECT(some.ctx, argName + ".ctx");
            InputChecks.IS_FN(some.fn, argName + ".fn");
        }
    }
    static HOST(host) {
        InputChecks.IS_STRING_NOT_EMPTY(host, "host");
        if (host.match(/^(http|https):\/\//) === null) {
            InputChecks.THROW_ERROR("Expected 'host' to be a valid host URL.");
        }
    }
    static NUM(num, argName, min, max) {
        InputChecks.CHECK_ARGUMENT_TYPE(num, argName, "number");
        if (num < min || num > max) {
            InputChecks.THROW_ERROR("Expected '" + argName + "' to be a number between " + min + " and " + max + ".");
        }
    }
    static GET_META_DATA(path, options = {}) {
        InputChecks.PATH(path);
        InputChecks.IS_OBJECT(options, "options");
    }
    static RENAME(oldPath, newPath) {
        InputChecks.PATH(oldPath, "oldPath");
        InputChecks.PATH(newPath, "newPath");
    }
    static RE_IMPORT(image = true, metaData = true) {
        if (modeNode)
            return;
        InputChecks.IS_BOOL(image, "image");
        InputChecks.IS_BOOL(metaData, "metaData");
    }
    static FN_OBJECT_OR_FUNCTION(some, argName) {
        InputChecks.NotEmptyTwoTypes(some, argName, "object", "function");
    }
    static OBJECT_OR_STRING(some, argName) {
        if (modeNode)
            return;
        InputChecks.NotEmptyTwoTypes(some, argName, "object", "string");
    }
    static SERVICE_FD(service) {
        InputChecks.IS_STRING_NOT_EMPTY(service, "service");
        if (service !== "file" && service !== "directory") {
            InputChecks.THROW_ERROR("Expected 'service' to be either 'file' or 'directory', but received '" + service + "'.");
        }
    }
    static META_DATA(path, data, service) {
        InputChecks.PATH(path);
        InputChecks.IS_OBJECT(data, "data");
        InputChecks.SERVICE_FD(service);
    }
    static COPY(path, toPath, listOptions) {
        InputChecks.PATH(path);
        InputChecks.PATH(toPath, "toPath");
        InputChecks.IS_OBJECT(listOptions, "listOptions");
    }
    static STRING_ARRAY(strings, argName) {
        InputChecks.IS_ARRAY_NOT_EMPTY(strings, argName);
        InputChecks.ARRAY_CONTAINS(strings, argName, "string");
    }
    static OBJECT_ARRAY(objects, argName) {
        InputChecks.IS_ARRAY_NOT_EMPTY(objects, argName);
        InputChecks.ARRAY_CONTAINS(objects, argName, "object");
    }
    static STRING_ARRAY_OR_EMPTY_ARRAY(strings, argName) {
        if (modeNode)
            return;
        InputChecks.IS_ARRAY(strings, argName);
        InputChecks.ARRAY_CONTAINS(strings, argName, "string");
    }
    static ARCHIVE_TYPE(type) {
        InputChecks.IS_STRING_NOT_EMPTY(type, "options.archiveType");
        if (type !== "zip" && type !== "tar.gz" && type !== "tar.bz2") {
            InputChecks.THROW_ERROR("Expected 'options.archiveType' to be 'zip', 'tar.gz' or 'tar.bz2', but received '"
                + type + "'.");
        }
    }
    static NotEmptyTwoTypes(some, argName, type1, type2) {
        if (!some) {
            InputChecks.THROW_ERROR("Argument '" + argName + "' empty or missing.");
        }
        if ((typeof (some) !== type1 && typeof (some) !== type2)) {
            InputChecks.THROW_ERROR("Expected '" + argName + "' to be of type '" + type1 + "' or '" + type2 + "', but received '"
                + typeof (some) + "'.");
        }
    }
    static THROW_ERROR(str) {
        throw (new Error(str));
    }
}
exports.InputChecks = InputChecks;
